import { cn } from '$lib/utils';
import { sizes, variants, type IconSize, type IconVariant } from './Icon.types';

export function getIconClasses(
	size: IconSize = 'md',
	variant: IconVariant = 'default',
	className?: string
) {
	return cn(
		sizes[size], // Narzuca rozmiar (np. size-5)
		variants[variant], // Narzuca kolor
		'shrink-0', // Zabezpieczenie przed zgniataniem w flexboxie
		className // Pozwala nadpisać coś w sytuacjach awaryjnych
	);
}
